let baseURL = ''
if (process.env.NODE_ENV === 'development') {
  baseURL = '/api'

} else if (process.env.NODE_ENV === 'production') {
  // baseURL = "https://msgaudit-api.yestarshop.com";//杭州
  baseURL = "https://msgaudit-api.zjnbys.top";//宁波
}
export default baseURL